export const cloudflareImageLoader = ({ src, width, quality }) => {
  const params = [`width=${width}`, `quality=${quality || 75}`, 'format=auto'];
  // Remove leading slash if present
  if (src.startsWith('/')) {
    src = src.slice(1);
  }
  return `https://www.keesy.com/cdn-cgi/image/${params.join(',')}/${src}`;
};
